'use client';
import React, { Children, PropsWithChildren, cloneElement } from 'react';
import { SelectLogParams } from '~/apis/log';
import { useSendLog } from '~/hooks';

type Props = {
  params?: SelectLogParams;
};
export const LogClick = ({ children, params }: PropsWithChildren<Props>) => {
  const sendLog = useSendLog();
  const child = Children.only(children);
  const isValidChild = React.isValidElement(child);

  if (!isValidChild) return null;

  const logging = () => {
    if (!params) return;
    sendLog({ ...params });
  };

  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  const handleClick = (...args: any[]) => {
    logging();

    const props = child.props as { onClick?: (...args: unknown[]) => void };
    if (typeof props.onClick === 'function') {
      props.onClick(...args);
    }
  };

  return cloneElement(child, {
    onClick: handleClick,
  } as React.DOMAttributes<HTMLElement>);
};
